import { isValidPermission, isAccountPermission } from './index.js';
import { UserMasqPermission, masqAccess, MasqAccess } from './masq.js';
// This should be written with zero-trust by default. Start from no access and
// gradually check for higher permissions.
export function checkPermission(user, account, 
// TODO: Later this should be Record<number, RoleDefinition>, when we switch to
// fetching roles exclusively from the API - the number will be the role ID.
// Right now the string is the role name (because the hard coded UI roles don't have IDs).
roles, permission, workspaceId) {
    if (!isValidPermission(permission) || user == null || account == null) {
        return false;
    }
    // Masq access — checked before write_access so that masq ReadWrite
    // can grant edit permissions even on read-only accounts.
    if (account.is_masq) {
        const access = masqAccess(user.masq_permissions);
        // This block could be compressed, but since it's important, let's be explicit.
        if (access === MasqAccess.None) {
            return false;
        }
        else if (access === MasqAccess.Read && !permission.endsWith('view')) {
            return false;
        }
        else if (access === MasqAccess.Read) {
            return true;
        }
        else if (access === MasqAccess.ReadWrite) {
            return true;
        }
    }
    // Read-only accounts
    if (!account.write_access && !permission.endsWith('view')) {
        return false;
    }
    // Checks user account permissions
    if (user.account_permissions != null && isAccountPermission(permission)) {
        // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
        return user.account_permissions.includes(permission);
    }
    // Check if the user has the permission through their role
    if (user.workspace_roles != null && roles != null && workspaceId != null) {
        const maybeRoleIdForWorkspace = user.workspace_roles[workspaceId];
        const maybeRole = maybeRoleIdForWorkspace != null ? roles[maybeRoleIdForWorkspace.name] : null;
        if (maybeRole != null) {
            // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
            return maybeRole.workspacePermissions.has(permission);
        }
        return false;
    }
    return false;
}
/**
 * Applies the masquerade read-only toggle to the masq level.
 *
 * A masq session starts read-only. `checkPermission` grants every permission to
 * a ReadWrite or SuperUser masq, so without this downgrade a read-only session
 * passes write checks.
 *
 * The toggle only removes access. A level that grants no more than Read is not
 * changed.
 */
export function applyMasqReadOnly(user, account, masqReadOnly) {
    if (user == null) {
        return null;
    }
    if (account?.is_masq !== true || !masqReadOnly) {
        return user;
    }
    if (masqAccess(user.masq_permissions) !== MasqAccess.ReadWrite) {
        return user;
    }
    return { ...user, masq_permissions: UserMasqPermission.ReadOnly };
}
//# sourceMappingURL=validation.js.map